import { useContext } from 'react';
import { AccountsContext } from './AccountsProvider';
import { CloudResourcesContext } from './CloudResourcesProvider';
import { InsightsContext } from './InsightsContextProvider';
import { RulesContext } from './RulesProvider';
import { AccountContext } from './AccountProvider';

export function useRulesContext() {
  const context = useContext(RulesContext);

  if (!context) {
    throw new Error(
      'The Rules Context must be used within an RulesContextProvider',
    );
  }

  return context;
}

export function useAccountsContext() {
  const context = useContext(AccountsContext);

  if (!context) {
    throw new Error(
      'The Accounts Context must be used within an AccountsContextProvider',
    );
  }

  return context;
}

export function useCloudResourcesContext() {
  const context = useContext(CloudResourcesContext);

  if (!context) {
    throw new Error(
      'The CloudResources Context must be used within an CloudResourcesContextProvider',
    );
  }

  return context;
}

export function useInsightsContext() {
  const context = useContext(InsightsContext);

  if (!context) {
    throw new Error(
      'The Insights Context must be used within an InsightsContextProvider',
    );
  }

  return context;
}

export function useAccountContext() {
  const context = useContext(AccountContext);

  if (!context) {
    throw new Error(
      'The Account Context must be used within an AccountContextProvider',
    );
  }

  return context;
}
